import { render, staticRenderFns } from "./Vertical.vue?vue&type=template&id=6a5b863e&"
import script from "./Vertical.vue?vue&type=script&lang=js&"
export * from "./Vertical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports